import React, { useEffect } from 'react';
import AOS from "aos";
import PageTitle from "../../components/PageTitle";
import WhiteSquare from "../../components/WhiteSquare";

import section21 from '../../assets/images/investment-section-2-1.png';
import section22 from '../../assets/images/investment-section-2-2.png';
import section31 from '../../assets/images/investment-section-3-1.png';
import section41 from '../../assets/images/investment-section-4-1.png';
import section51 from '../../assets/images/investment-section-5-1.png';

const Investment = () => {
  useEffect(() => {
    AOS.refreshHard();
  });
  return (
    <div className="investment">
      <div className="section-1">
        <PageTitle title="Investment" subTitle="Platform" description={<p>스마트 컨트랙트 기술개발,<br className="show-mobile" /> 커스터마이징툴<br className="show-pc" /> 기술개발을 위한<br className="show-mobile" /> 기업 부설 연구소</p>} />
        <WhiteSquare />
      </div>
      <div className="section-2">
        <div>
          <div className="blue-title title">1 전문연구 분야</div>
          <div className="content">
            <img alt="image" src={section21} />
            <p>
              블록체인의 생성, 폐기, 교환 등 <br />
              블록체인 스마트 컨트랙트 <br />
              트랜잭션 기술
            </p>
          </div>
        </div>
        <div>
          <div className="purple-title title">2 전문연구 분야</div>
          <div className="content">
            <img alt="image" src={section22} />
            <p>
              사용자의 편의성을 극대화한 <br />
              언리얼 5용 NFT 창작툴 개발
            </p>
          </div>
        </div>
      </div>
      <div className="section-3">
        <div className="text-wrap" data-aos="fade-right" data-aos-duration="1000" data-aos-anchor-placement="top-bottom">
          <div className="number">
            <p>1</p>
            <div className="background"/>
          </div>
          <div>
            <p className="title">블록체인 데이터의<br /><span>실시간 소유권 증명</span></p>
            <p className="text">탈중앙화 시스템을 사용하는 블록체인에서<br className="show-mobile" /> 생성된 토큰의<br className="show-pc" />
              발행, 교환, 폐기 등 트랜젝션을<br className="show-mobile" /> 메타버스가 구현되어 있는<br className="show-pc" />
              중앙화 서버에<br className="show-mobile" /> 실시간으로 데이터를 동기화하고<br />
              상호 데이터의 무결성을 검증하고<br className="show-mobile" /> 유지하는 방안 연구</p>
          </div>
        </div>
        <img alt="image" src={section31} data-aos="fade-left" data-aos-duration="1000" data-aos-anchor-placement="top-bottom" />
      </div>
      <div className="section-4" >
        <img alt="image" src={section41} data-aos="fade-up" data-aos-duration="1500" data-aos-offset="0" data-aos-anchor-placement="top-bottom" />
        <div className="text-wrap" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="0" data-aos-anchor-placement="top-bottom">
          <div className="number">
            <p>2</p>
            <div className="background"/>
          </div>
          <div>
            <p className="title">NFT 메타데이터의 <span>표준화</span> 및 <br />
              저장소의 <span>탈중앙화</span> 연구</p>
            <p className="text">
              타 플랫폼에서 발행된 NFT와 당사에서<br className="show-mobile" /> 발행된 NFT를<br className="show-pc" /> 자유롭게 사용하기 위한<br className="show-mobile" /> 스마트 컨트랙트 표준안을 기반으로<br />
              서비스의 장애발생 및 종료와 무관하게
              <br />NFT의 가치가 훼손되지 않도록<br className="show-mobile" /> 탈중앙화된 메타데이터 저장소 연구
            </p>
          </div>
        </div>
      </div>
      <div className="section-5">
        <div className="text-wrap" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="0" data-aos-anchor-placement="top-bottom">
          <div className="number">
            <p>3</p>
            <div className="background"/>
          </div>
          <div>
            <p className="title">메타버스 내 <br /><span>NFT 제작 어플리케이션</span> 개발</p>
            <p className="text">
              메타버스를 이용하는 사용자들의 <br />
              다양한 NFT 창작물을 만들기 위한 <br /> 오브젝트 배치, 변형 자동화 등<br className="show-mobile" /> 커스터마이징툴 개발
            </p>
          </div>
        </div>
        <img alt="image" src={section51} data-aos="fade-up" data-aos-duration="1500" data-aos-offset="0" data-aos-anchor-placement="top-bottom" />
      </div>
    </div>
  )
}

export default Investment